import { html, nothing } from "lit-html";
import { classMap } from "lit-html/directives/class-map.js";
import { Base } from "../../../shared/components/dialogs/Base";
import connect from "../../../shared/data-store/connect";
import { store, ACTION_REMOVE_ALL_FILTER } from "./DataStore";
import { scrollToTop } from "../../dom/smoothScroll";
import { translate } from "../../../shared/l10n/translate";
import "./PriceFilterSection";
import "./BoardFilter";
import "./ClassificationFilter";
import "./ScoreFilter";
import "./MultiToggleFilter";
import "./RecentlyUsedFilters";
import { trackReset } from "./ResetFilters";
import { track } from "../../tracker/EventTracker";
import { data } from "@escapio/shared/state/payload";
import unsaferHTML from "@escapio/shared/unsaferHTML";

export class FilterDialog extends connect(Base, store) {
	constructor(opener) {
		super();
		this.initialHash = null;
		this.previousHash = null;
		this.historyChanges = 0;
		this.node.classList.add("dialog--filter");
		this.trackLabelSuffix =
			opener && opener.hasAttribute("track-label-suffix")
				? ` ${opener.getAttribute("track-label-suffix")}`
				: "";
	}

	show() {
		this.initialHash = window.location.hash;
		this.previousHash = this.initialHash;
		this.historyChanges = 0;
		super.show();
		track(
			"Filter",
			"Filter Layer geöffnet",
			`${data.trackingId} | ${data.prepositionedArticleTitle}${this.trackLabelSuffix}`,
		);
	}

	hide() {
		if (this.historyChanges) {
			history.go(this.historyChanges);
		}
		super.hide();
		scrollToTop(document.getElementById("search-panel"));
	}

	getTemplateHeaderLeft() {
		return store.filtersCount > 2
			? html`
					<button class="dialog__reset-all-button" @click=${this.onResetAll}>
						${translate("filter_dialog_reset_all")}
					</button>
				`
			: nothing;
	}

	getTemplateHeaderMiddle() {
		return html`<i class="fa fa-sliders"></i>`;
	}

	getTemplateContent() {
		return html`
			<esc-hotel-list-price-filter-section
				track-label-suffix="${this.trackLabelSuffix}"
				class="filter-box__section"
			></esc-hotel-list-price-filter-section>
			<esc-hotel-list-board-filter
				track-label-suffix="${this.trackLabelSuffix}"
				class="filter-box__section"
			></esc-hotel-list-board-filter>
			<esc-hotel-list-score-filter
				track-label-suffix="${this.trackLabelSuffix}"
				class="filter-box__section"
			></esc-hotel-list-score-filter>
			<esc-hotel-list-recently-used-filters
				track-label-suffix="${this.trackLabelSuffix}"
				class="filter-box__section"
			></esc-hotel-list-recently-used-filters>
			<esc-hotel-list-multi-toggle-filter
				track-label-suffix="${this.trackLabelSuffix}"
				class="filter-box__section"
				filterName="criteria"
			></esc-hotel-list-multi-toggle-filter>
			<esc-hotel-list-classification-filter
				track-label-suffix="${this.trackLabelSuffix}"
				class="filter-box__section"
			></esc-hotel-list-classification-filter>
			<esc-hotel-list-multi-toggle-filter
				track-label-suffix="${this.trackLabelSuffix}"
				class="filter-box__section"
				filterName="hotelTypes"
			></esc-hotel-list-multi-toggle-filter>
		`;
	}

	getTemplateFooter() {
		const count = store.counters.unfiltered;
		return html`
			<div
				class="dialog__bottom-bar ${classMap({
					"dialog__bottom-bar--show": this.initialHash != window.location.hash,
				})}"
			>
				<button
					class="action-button dialog__bottom-bar__button"
					?disabled=${this.initialHash == window.location.hash}
					@click=${this.applyAndClose}
				>
					${unsaferHTML(
						count == 1
							? translate(
									"filter_dialog_apply_singular",
									`<strong>${count}</strong>`,
								)
							: translate(
									"filter_dialog_apply_plural",
									`<strong>${count}</strong>`,
								),
					)}
				</button>
			</div>
		`;
	}

	update() {
		// Check for new entry in history.
		if (this.previousHash != window.location.hash) {
			this.previousHash = window.location.hash;
			this.historyChanges--;
		}
		this.render();
	}

	onResetAll() {
		this.dispatchAction(ACTION_REMOVE_ALL_FILTER);
		trackReset("Zuruecksetzen");
		this.applyAndClose();
	}

	applyAndClose() {
		// New list state will not be reset when dialog is closed:
		this.historyChanges = 0;
		this.hide();
	}
}
